import { useMutation, useQueryClient } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import _ from 'lodash';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

import { ScheduledContributionStatus } from '../ScheduledContribution.types';
import { ScheduledContributionState } from '../stores/useScheduledContribution.store';

import { SCHEDULED_CONTRIBUTION_QUERY_KEY } from './useScheduledContributionList.query';

interface Payload extends ScheduledContributionState {}
interface Params {
  isEditMode?: boolean;
  contributionId?: string;
}
export default ({ isEditMode }: Params) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    (payload: Partial<Payload>) =>
      isEditMode && payload.contributionId
        ? api.patch(`${API_URL.SCHEDULED_CONTRIBUTIONS}/${payload.contributionId}`, {
            calendar_id: _.toNumber(payload.calendarId),
            start_date: dayjs(payload.startDate, DEFAULT_DATE_FORMAT).format(RAW_DATE_FORMAT),
            tax_type: payload.taxType,
          })
        : api.post(API_URL.SCHEDULED_CONTRIBUTIONS, {
            calendar_id: _.toNumber(payload.calendarId),
            tax_type: payload.taxType,
            status: ScheduledContributionStatus.Active,
            start_date: dayjs(payload.startDate, DEFAULT_DATE_FORMAT).format(RAW_DATE_FORMAT),
          }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [SCHEDULED_CONTRIBUTION_QUERY_KEY],
        });
      },
    }
  );

  return {
    handleSave: mutateAsync,
    isLoading,
    isSuccess,
  };
};
